import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import AOS from 'aos';
import 'aos/dist/aos.css';
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner7 from '../assets/banner7.jpg';
import service1 from '../assets/banner1.jpg';
import img1 from "../assets/gallery/1.jpg";
import img2 from "../assets/gallery/2.jpg";
import img3 from "../assets/gallery/3.jpg";
import img4 from "../assets/gallery/4.jpg";
import img5 from "../assets/gallery/5.jpg";
import img6 from "../assets/gallery/6.JPG";
import img7 from "../assets/gallery/7.jpg";
import img8 from "../assets/gallery/8.jpg";
import img9 from "../assets/gallery/9.jpg";
import img10 from "../assets/gallery/10.jpg";
import img11 from "../assets/gallery/11.jpg";
import img12 from "../assets/gallery/12.jpg";
import img13 from "../assets/gallery/13.jpg";
import img14 from "../assets/gallery/14.jpg";
import img15 from "../assets/gallery/15.jpg";

import { IoMdAlert, IoMdArrowDropright, IoMdCheckmarkCircleOutline, IoMdDocument } from "react-icons/io";
import { FaArrowCircleRight, FaCalendarAlt, FaCogs, FaImage, FaSearch, FaSeedling, FaSyncAlt, FaTachometerAlt, FaUsersCog } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import OneService from "./OneService";
import { TbDeviceCctv } from "react-icons/tb";
import { FaComputer, FaGun, FaPeopleGroup } from "react-icons/fa6";
import { MdCorporateFare } from "react-icons/md";

const importImages = () => {
  const images = [];
  for (let i = 1; i <= 15; i++) {
    images.push(require(`../assets/gallery/${i}.jpg`));
  }
  return images;
};


export default function GalleryContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	const images = [
		img1, img2, img3, img4, 
		img6, ,img14, img9, img10,
		img11, img12, img13, img15, img5, img7, img8, 
	];


	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	useEffect(() => {
    AOS.init({ duration: 1000, easing: 'ease-in-out', once: false });
    AOS.refresh(); // optional: refresh if content changes dynamically
  }, []);

	

	if (ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-12">
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
												textTransform: "capitalize",
											}}
										>
											Our Gallery
										</h1>
									</div>
								</div>

							</div>
						</div>
	
					</div>
				</div>

				<div className="MainBodySection">
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<h3 className="main-section-title my-5">
									A curated showcase of our images highlighting key moments and projects.
								</h3>
							</div>
						</div>

						<div className="row g-3 mb-5">
							{images.map((imgSrc, index) => (
							<div key={index} className="col-6 col-md-4">
								<div className="position-relative overflow-hidden rounded shadow-sm">
								<a href={imgSrc} target="_blank" rel="noopener noreferrer">
									<img
										src={imgSrc}
										alt={`Photo ${index + 1}`}
										className="img-fluid"
										style={{ transition: "transform 0.3s ease" }}
									/>
									<FaImage
										className="position-absolute translate-middle text-white rounded bg-secondary p-1"
										style={{ fontSize: "1.5rem", opacity: 0.8, pointerEvents: "none", display: "grid", placeItems: "center", bottom: "1%", right: "1%" }}
										size={28}
									/>
								</a>
								</div>
							</div>
							))}
						</div>

					</div>
				</div>
			</>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
